
<input type="text" :value="actualValue" :placeholder="placeholderText" @input="onInput($event)" class="flatpickr-input" :aria-required="required" :aria-describedby="describedBy">
